import { queryOptions } from '@tanstack/react-query'

import { fetchSeries, fetchSeriesDetail } from '#admin/features/platform/series/api.ts'

export const seriesQuery = () =>
  queryOptions({
    queryKey: ['platform', 'series'],
    queryFn: ({ signal }) => fetchSeries(signal),
    staleTime: 60_000,
  })

/** One series with its editions compared. Keyed under the list, so a list refresh refreshes it. */
export const seriesDetailQuery = (seriesId: string) =>
  queryOptions({
    queryKey: ['platform', 'series', seriesId],
    queryFn: ({ signal }) => fetchSeriesDetail(seriesId, signal),
    staleTime: 30_000,
  })
